import { FormattedMessage } from 'react-intl';
import { getLinkTrackingAttributes } from '../../../../../tracking/clickTracking';

export const FleetGroupExplanation = () => (
    <>
        <h4 className='margin-bottom-10'>
            <FormattedMessage id={'intl-msg:header.info.entities.fleetgroups.title'} />
        </h4>
        <div>
            <FormattedMessage id={'intl-msg:header.info.entities.fleetgroups.text'} />{' '}
            <a
                className='link'
                href='https://administration.assets.rio.cloud/'
                {...getLinkTrackingAttributes('header.info.entities.fleetgroups.linktext')}
            >
                <FormattedMessage id={'intl-msg:header.info.entities.fleetgroups.linktext'} />
            </a>
            {'.'}
        </div>
    </>
);
